"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _svgIcon = require("../SvgIcon");
var _default = (0, _svgIcon).makeIcon("Icon24Chevron", "chevron_24", "0 0 16 24", '<symbol viewBox="0 0 16 24" xmlns="http://www.w3.org/2000/svg" id="chevron_24"><g fill="none" fill-rule="evenodd"><path d="M0 0h16v24H0z" /><path d="M4.706 7.706a1 1 0 0 1 0-1.412l.088-.088a.997.997 0 0 1 1.414.002l5.084 5.084a.998.998 0 0 1 0 1.416l-5.084 5.084a1.002 1.002 0 0 1-1.414.002l-.088-.088a.995.995 0 0 1 0-1.412L9 12 4.706 7.706Z" fill="currentColor" /></g></symbol>', 16, 24, false, undefined);
exports.default = _default;
